import React from 'react';

const InternationalForum = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>International Forum</h1>
        <p>Global business networking platform</p>
      </section>
      <section className="page-content">
        <div className="container">
          <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#E6D88A'}}>
            The International Forum brings together global investors, business leaders, 
            and policymakers to explore investment opportunities across Africa.
          </p>
          <div className="content-grid" style={{marginTop: '30px'}}>
            <div className="content-card">
              <h3>Networking</h3>
              <p>Connect with industry leaders and investors.</p>
            </div>
            <div className="content-card">
              <h3>Investment Opportunities</h3>
              <p>Discover emerging markets and sectors.</p>
            </div>
            <div className="content-card">
              <h3>Policy Dialogues</h3>
              <p>Engage with policymakers on trade and investment.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternationalForum;